/**
 * 配置编译环境和线上环境之间的切换
 *
 * baseUrl: 域名地址
 * routerMode: 路由模式
 * baseImgPath: 图片存放地址
 *
 */
let baseUrl = '';
let routerMode = 'hash';
let baseImgPath;

if (process.env.NODE_ENV == 'development') { //开发环境
    //baseUrl = '/api';
    //baseImgPath = '/';
}else{ //生产环境
    // baseUrl = 'https://huli.novocare.cn';
    // baseUrl = 'http://xiangya.novocare.cn:8888';
    // baseUrl = 'https://op.xyrehab.com'
    baseUrl = 'https://boai.xyrehab.com'
    // baseUrl = 'http://111.8.62.117:9070'
    baseImgPath = '../../';
}

export {
    baseUrl,
    routerMode,
    baseImgPath
}



// WEBPACK FOOTER //
// ./src/config/env.js